const UpIcon = ({ height = "7", width = "12", viewBox = "0 0 12 7", className = "hayley-h-6 hayley-w-6 hayley-text-secondary" }) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path d="M11 6L6 1L1 6" stroke="#333333" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};

export default UpIcon;
